<template>
  <div>
    <div class="yellow-btn radio" style="text-align: left" @click="dialogVisible = true"><i class="iconfont iconjia1"></i>创建文件夹</div>
    <!-- 上传文件按钮 -->
    <div class="other-set" @click="uploadDia = true">
      <i class="iconfont iconshangchuan"></i>上传文件
<!--      <el-upload-->
<!--        style="position:absolute;top: 0;left: 0;width: 100%;height: 100%;"-->
<!--        :action="domain"-->
<!--        :data="QiniuData"-->
<!--        :on-error="uploadError"-->
<!--        :on-success="uploadSuccess"-->
<!--        :before-upload="beforeAvatarUpload"-->
<!--        :show-file-list="false"-->
<!--        multiple-->
<!--        :file-list="fileList">-->
<!--      </el-upload>-->
    </div>
    <!-- 上传文件夹按钮 -->
<!--    <div class="other-set" style="position:relative;">-->
<!--      <i class="iconfont iconbanbenxinjian"></i>上传文件夹-->
<!--      <input ref="file" class="fileUploaderClass" type='file' name="file"-->
<!--             webkitdirectory style="position: absolute;left: 0;top: 0;width:100%;height:100%;opacity: 0;"-->
<!--             @change="getFiles"-->
<!--      />-->
<!--    </div>-->
    <div class="other-set" @click="showOther"><i class="iconfont icondaoru"></i>从项目添加文档和文件</div>
    <div class="jiange"></div>
    <div class="other-set"><i class="iconfont iconpaixu"></i>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link" style="color: #0a2240">
          {{paixu}}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1,按目录排序">按目录排序</el-dropdown-item>
          <el-dropdown-item command="2,按文件名称正序">按文件名称正序</el-dropdown-item>
          <el-dropdown-item command="3,按文件名称降序">按文件名称降序</el-dropdown-item>
          <el-dropdown-item command="4,按修改人名称正序">按修改人名称正序</el-dropdown-item>
          <el-dropdown-item command="5,按修改人名称降序">按修改人名称降序</el-dropdown-item>
          <el-dropdown-item command="6,按修改时间正序">按修改时间正序</el-dropdown-item>
          <el-dropdown-item command="7,按修改时间降序">按修改时间降序</el-dropdown-item>
          <el-dropdown-item command="8,按文件类型">按文件类型</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="other-set" @click="toClose"><i class="iconfont iconshanchu"></i>回收站</div>
    <el-dialog
      title="创建文件夹"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div>
        <el-input v-model="addName" placeholder="请输入文件夹名称"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addWjj">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择文件"
      :visible.sync="dialogVisible2"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="pro-chiose">
        <el-button class="pro-name" :class="{active:proChiose === 0}" @click="proChiose = 0">益书宝</el-button>
        <el-button class="pro-name" :class="{active:proChiose === 1}" @click="proChiose = 1">益会宝</el-button>
        <el-button class="pro-name" :class="{active:proChiose === 2}" @click="proChiose = 2">益宣宝</el-button>
        <el-button class="pro-name" :class="{active:proChiose === 3}" @click="proChiose = 3">益算宝</el-button>
      </div>
      <div v-if="proChiose === 0">
        <el-tree
          :data="data2"
          ref="tree1"
          show-checkbox
          node-key="id"
          :props="defaultProps">
        </el-tree>
      </div>
      <div v-if="proChiose === 1">
        <el-tree
          :data="data3"
          ref="tree2"
          show-checkbox
          node-key="id"
          :props="defaultProps3">
        </el-tree>
      </div>
      <div v-if="proChiose === 2">
        <el-tree
          :data="data4"
          ref="tree3"
          show-checkbox
          node-key="id"
          :props="defaultProps4">
        </el-tree>
      </div>
      <div v-if="proChiose === 3">
        <el-tree
          :data="data5"
          ref="tree4"
          show-checkbox
          node-key="id"
          :props="defaultProps5">
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="sureChiose">确 定</el-button>
      </span>
    </el-dialog>
    <upLoadFiles
      :uploadDia="uploadDia"
      @syncFile="syncFile"
    ></upLoadFiles>
  </div>
</template>

<script>
  // import {genUpToken} from '../../tools/CryptoJS'
  import upLoadFiles from "@/views/components/upLoadFiles";
  export default {

    data() {
      return {
        dialogVisible: false,      //  创建文件夹
        uploadDia:false,
        addName: '',                //  创建文件夹名称,
        kname: '',                  //   库名称
        QiniuData: {
          fname: '', //  文件名
          key: "", //文件名字处理
          token: "" //七牛云token
        },
        domain: "https://upload-z2.qiniup.com/", // 七牛云的上传地址（华南区）
        qiniuaddr: "https://zsglimg.emof.cn", // 七牛云的图片外链地址 你的七牛云里配置有
        uploadPicUrl: "", //提交到后台图片地址
        fileList: [],
        nowTime: '',
        fileExtension: '',
        loading: null,
        paixu: '按目录排序',
        paixuId: 1,
        dialogVisible2: false, //  文件导入
        data2: [], //  需要导入      益书宝
        defaultProps: {
          children: 'detail',
          label: 'title'
        },
        data3: [], //  需要导入      益会宝
        defaultProps3: {
          children: 'detail',
          label: 'title'
        },
        data4: [], //  需要导入      益宣宝
        defaultProps4: {
          children: 'detail',
          label: 'title'
        },
        data5: [], //  需要导入      益算宝
        defaultProps5: {
          children: 'detail',
          label: 'title'
        },
        proChiose: 0,
      }
    },
    components:{
      upLoadFiles
    },
    props: {
      KuName: {
        type: String,
        default: ''
      }
    },
    created() {
      // this.kname = this.KuName
      // this.nowTime = this.getDate();
      // var token;
      // var policy = {};
      // var bucketName = 'zhishiguanli';//你的七牛桶名称
      // var AK = '_MhT6BWLiDGy2755HTwoxzNH747ecCtlqldVq3p3'; //你的七牛AK
      // var SK = '15juIkGIozY13PvocO4o5lckBFb-OzqFrSVAAM7z';//你的七牛SK
      // var deadline = Math.round(new Date().getTime() / 1000) + 3600;
      // policy.scope = bucketName;
      // policy.deadline = deadline;
      // token = genUpToken(AK, SK, policy);
      // this.QiniuData.token = token;
    },
    methods: {
      syncFile(){
        this.uploadDia =false
        this.$emit('isAdd')
      },
      /*
      * 确定选择
      * */
      sureChiose() {
        if (this.proChiose === 0) {
          let arr = this.$refs.tree1.getCheckedNodes();
          let arr2 = []
          arr.map(item => {
            if (!item.foldername) {
              arr2.push(item.id)
            }
          })
          if (arr2.length === 0) {
            this.$message.error('未选择文件，请确认')
            return
          }
          this.$api.apiContent.Export({
            ids: arr2.join(','),
            mid: this.$store.state.userMid,
            folderid: this.$route.query.cid,
            kid: this.$route.query.id,
            username: this.$store.state.userName,
          }).then(() => {
            this.$message.success('上传成功')
            this.$emit('isAdd')
            this.dialogVisible2 = false
          }).catch(e => {
            this.$message.error(e.msg)
          })
        } else if (this.proChiose === 1) {
          let arr3 = this.$refs.tree2.getCheckedNodes();
          let arr2 = []
          arr3.map(item => {
            arr2.push(item.id)
          })
          if (arr2.length === 0) {
            this.$message.error('未选择会议，请确认')
            return
          }
          this.$api.apiContent.YhbExportMore({
            ids: arr2.join(','),
            mid: this.$store.state.userMid,
            folderid: this.$route.query.cid,
            kid: this.$route.query.id,
            username: this.$store.state.userName,
          }).then(() => {
            this.$message.success('上传成功')
            this.$emit('isAdd')
            this.dialogVisible2 = false
          }).catch(e => {
            this.$message.error(e.msg)
          })
        } else if (this.proChiose === 2) {
          let arr4 = this.$refs.tree3.getCheckedNodes();
          let arr2 = []
          arr4.map(item => {
            arr2.push(item.id)
          })
          if (arr2.length === 0) {
            this.$message.error('未选择文件，请确认')
            return
          }
          this.$api.apiContent.YxbExportMore({
            ids: arr2.join(','),
            mid: this.$store.state.userMid,
            folderid: '',
            kid: this.$route.query.id,
            username: this.$store.state.userName,
          }).then(() => {
            this.$message.success('上传成功')
            this.$emit('isAdd')
            this.dialogVisible2 = false
          }).catch(e => {
            this.$message.error(e.msg)
          })
        } else if (this.proChiose === 3) {
          let arr5 = this.$refs.tree4.getCheckedNodes();
          let arr2 = []
          arr5.map(item => {
            arr2.push(item.id)
          })
          if (arr2.length === 0) {
            this.$message.error('未选择文件，请确认')
            return
          }
          this.$api.apiContent.SuanexportToEmof({
            ids: arr2.join(','),
            mid: this.$store.state.userMid,
            folderid: this.$route.query.cid,
            kid: this.$route.query.id,
            username: this.$store.state.userName,
          }).then(() => {
            this.$message.success('上传成功')
            this.$emit('isAdd')
            this.dialogVisible2 = false
          }).catch(e => {
            this.$message.error(e.msg)
          })
        }

      },
      /*
      * 获取其它项目的文件夹
      * */
      showOther() {
        this.$api.apiContent.GetTree({
          mid: this.$store.state.userMid,
          tid: 1
        }).then((res) => {
          res.data.map(item => {
            item.title = item.foldername
            item.detail.map(items => {
              items.title = items.title + '.doc'
              items.detail = []
            })
          })
          this.data2 = res.data
          this.dialogVisible2 = true
        }).catch(e => {
          this.$message.error(e.msg)
        })
        this.$api.apiContent.YhbGetTree({
          mid: this.$store.state.userMid
        }).then((res) => {
          res.data.map(item => {
            item.detail = []
          })
          this.data3 = res.data

        }).catch(e => {
          this.$message.error(e.msg)
        })
        this.$api.apiContent.YxbGetTree({
          mid: this.$store.state.userMid
        }).then((res) => {
          res.data.map(item => {
            item.detail = []
          })
          this.data4 = res.data

        }).catch(e => {
          this.$message.error(e.msg)
        })
        this.$api.apiContent.SuanGetTree({
          mid: this.$store.state.userMid
        }).then((res) => {
          res.data.map(item => {
            item.detail = []
          })
          this.data5 = res.data

        }).catch(e => {
          this.$message.error(e.msg)
        })


      },


      getFiles(file) {
        this.loading = this.$loading({
          lock: true,
          text: '上传中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let arr = [];
        let num = 0;
        console.log(file.target.files)
        for (var i = 0; i < file.target.files.length; i++) {
          if (file.target.files[i].name === '.DS_Store') {
            num++
            if (num === file.target.files.length) {
              this.upWenjianjia(arr)
            }
            continue;
          }
          let data = new FormData();
          data.append('file', file.target.files[i])
          data.append('fname', file.target.files[i].name)
          data.append('key', `${this.nowTime}${file.target.files[i].name}`)
          data.append('token', this.QiniuData.token)
          arr.push({
            label: file.target.files[i].name,    //  原文件名
            filesize: file.target.files[i].size, //  文件大小
            key: `${this.nowTime}${file.target.files[i].name}`,
            path: file.target.files[i].webkitRelativePath,
            filetype: file.target.files[i].name.split(".").pop()
          })
          this.$api.apiContent.file2(data).then(() => {
            num++
            if (num === file.target.files.length) {
              this.upWenjianjia(arr)
            }
          }).catch(() => {
            num++
            console.log(num)
            console.log(file.target.files.length)
            if (num === file.target.files.length) {
              this.upWenjianjia(arr)
            }
          })
        }
      },
      //  给后台上传文件夹的数据
      upWenjianjia(arr) {
        //在这里你就可以获取到上传到七牛的外链URL了
        this.$api.apiContent.Uploadmore({
          mid: this.$store.state.userMid,
          folderid: this.$route.query.cid,
          kid: this.$route.query.id,
          data: JSON.stringify(arr)
        }).then(() => {
          this.loading.close();
          this.$message.success('上传成功')
          this.$emit('isAdd')
          this.$refs.file.value = ''
        }).catch(e => {
          this.$message.error(e.msg)
        })
      },
      //  去回收站
      toClose() {
        this.$router.push({
          path: '/home/repositoriesClose',
          query: {
            id: this.$route.query.id,      //  知识库id
            name: this.kname  //    知识库名称
          }
        })
      },
      //  排序
      handleCommand(command) {
        let _arr = command.split(',')
        if (Number(_arr[1]) === this.paixuId) {
          return
        }
        this.paixu = _arr[1]
        this.paixuId = _arr[0]
        this.$emit('paixu', this.paixuId)
      },
      //  添加文件夹
      addWjj() {
        let that = this
        if (!that.addName) {
          that.$message.error('请填写文件夹名称')
        }

        that.$api.apiContent.checktitle({
          mid: that.$store.state.userMid,
          title: that.addName,
          team: that.$route.query.id,
          parentid: that.$route.query.cid,
          username: that.$store.state.userName,
          kid: this.$route.query.id
        }).then(() => {
          that.$api.apiContent.AddFolder({
            mid: that.$store.state.userMid,
            title: that.addName,
            team: that.$route.query.id,
            parentid: that.$route.query.cid,
            username: that.$store.state.userName,
            kid: this.$route.query.id
          }).then(res => {
            that.$message.success(res.msg)
            that.addName = ''
            that.dialogVisible = false
            that.$emit('isAdd')
          }).catch(e => {
            that.$message.error(e.msg)
          })
        }).catch(() => {
          that.$confirm('当前文件夹名称已存在，文件夹将重命名', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.$api.apiContent.AddFolder({
              mid: that.$store.state.userMid,
              title: that.addName,
              team: that.$route.query.id,
              parentid: that.$route.query.cid,
              username: that.$store.state.userName,
              kid: this.$route.query.id
            }).then(res => {
              that.$message.success(res.msg)
              that.addName = ''
              that.dialogVisible = false
              that.$emit('isAdd')
            }).catch(e => {
              that.$message.error(e.msg)
            })
          }).catch(() => {

          });

        })


      },
      //  上传前判断
      beforeAvatarUpload(file) {
        //这里的key给加上了时间戳，目的是为了防止上传冲突
        this.QiniuData.fname = file.name;
        this.QiniuData.key = `${this.nowTime}${file.name}`;
        this.loading = this.$loading({
          lock: true,
          text: '上传中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      //  上传成功
      uploadSuccess(response, file, fileList) {
        console.log(file);
        console.log(fileList);
        this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
        console.log(this.uploadPicUrl);
        //在这里你就可以获取到上传到七牛的外链URL了
        this.$api.apiContent.addFile({
          mid: this.$store.state.userMid,
          folderid: this.$route.query.cid,
          label: file.name,
          filesize: file.size,
          kid: this.$route.query.id,
          savename: response.key,
          username: this.$store.state.userName,
          filetype: file.name.split(".").pop()
        }).then(() => {
          this.loading.close();
          this.$message.success('上传成功')
          this.$emit('isAdd')
        }).catch(e => {
          this.$message.error(e.msg)
        })
      },
      //  上传失败
      uploadError(err, file, fileList) {
        console.log(err)
        console.log(file)
        console.log(fileList)
        this.loading.close();
        this.$message({
          message: "上传出错，请重试！",
          type: "error",
          center: true
        });
      },

      //以下是时间戳函数
      getDate() {
        var myDate = new Date();
        //获取当前年
        var year = myDate.getFullYear();
        //获取当前月
        var month = myDate.getMonth() + 1;
        //获取当前日
        var date = myDate.getDate();
        var h = myDate.getHours(); //获取当前小时数(0-23)
        var m = myDate.getMinutes(); //获取当前分钟数(0-59)
        var s = myDate.getSeconds();
        //获取当前时间
        var now = year + this.conver(month) + this.conver(date) + this.conver(h) + this.conver(m) + this.conver(s) + "_";
        return now;
      },
      conver(s) {
        return s < 10 ? '0' + s : s;
      },
    },
    watch: {
      KuName() {
        this.kname = this.KuName
      }

    }
  }
</script>

<style scoped lang="scss">
  .add-wjj {
    width: 200px;
    height: 45px;
    line-height: 45px;
    margin: 0 auto 10px;
    text-align: center;
    background: #0a2240;
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
  }

  .other-set {
    width: 200px;
    height: 40px;
    padding: 0 15px;
    line-height: 40px;
    margin: 20px auto ;
    text-align: left;
    color: #0a2240;
    cursor: pointer;
    position: relative;
    background: #fff;
    border-radius: 20px;

    i {
      padding-right: 5px;
    }

    &:hover {
      color: #475ab5;
    }
  }

  .jiange {
    border-bottom: 1px solid #fff;
    margin: 20px 0 10px;
  }

  .pro-chiose {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 20px;

    .pro-name {
      width: 150px;

      &.active {
        background: #0a2240;
        color: #fff;
      }
    }
  }
</style>
